var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import "./index.css";
let DataPathSelector = class DataPathSelector extends Vue {
  get dataStub() {
    var _this$designer;
    if (!this.value) return null;
    return (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.renderer) === null || _this$designer === void 0 ? void 0 : _this$designer.getStubAtPath(this.value);
  }
  handleInputBoxClick(ev) {
    ev.preventDefault();
    this.showPopover();
  }
  commit(path) {
    this.$emit('change', path);
  }
  showPopover() {
    var _this$designer2;
    const place = this.$refs.placeProvider;
    (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || _this$designer2.openDataPathSelector({
      place,
      width: place.offsetWidth,
      currentDataPath: this.value || '',
      filter: this.filter,
      selectorOnly: !!this.selectorOnly
    }).then(answer => {
      if (answer) this.commit(answer);
    });
  }
  /**
   * 当前是否允许创建变量
   */
  get canCreateStateVariable() {
    if (this.alwaysShowCreateButton && this.exampleVariableName && this.exampleSchema) return true;
    if (this.dataStub) return false; // 如果现在已经有选择一个数据源，就不让他创建了
    return !!(this.exampleVariableName && this.exampleSchema);
  }
  /**
   * 执行创建变量的逻辑
   */
  async createStateVariable() {
    if (!this.canCreateStateVariable) return;
    const result = await this.designer.openCreateStateVariableDialog({
      id: this.exampleVariableName,
      place: this.$el,
      schema: this.exampleSchema
    });
    if (result !== null && result !== void 0 && result.dataPath) this.commit(result.dataPath);
    return result;
  }
  /**
   * 当前是不是一个 state 页面变量
   */
  get canEditStateVariable() {
    const {
      dataStub
    } = this;
    if (!dataStub || dataStub.pathParts.length !== 2 || dataStub.pathParts[0] !== 'state') return false;
    return true;
  }
  /**
   * 当前如果是一个 state 页面变量，可编辑他！
   */
  async editStateVariable() {
    if (!this.canEditStateVariable) return;
    const dataStub = this.dataStub;
    const id = dataStub.pathParts[1];
    const oldDataPath = dataStub.path;
    const result = await this.designer.openEditStateVariableDialog({
      id,
      place: this.$el
    });
    // 如果变量ID变了，要触发一下修改
    if (result && result.dataPath !== oldDataPath) this.commit(result.dataPath);
    return result;
  }
  /**
   * 配合 hooks.getActionsOfDataSource 使用的
   *
   * 会在选择框下面，展示一些链接和入口
   */
  get dsActionsSlot() {
    var _list, _list2;
    const h = this.$createElement;
    const {
      dataStub,
      designer
    } = this;
    if (!dataStub || !designer || !designer.renderer) return null;
    const {
      uc
    } = designer;
    let list = [];
    list = uc.hooks.getActionsOfDataSource.call(list, {
      uc,
      designer,
      renderer: designer.renderer,
      dataStub,
      dataPath: dataStub.path,
      dataSchema: dataStub.schema
    });
    list = (_list = list) === null || _list === void 0 ? void 0 : _list.filter(it => it.position === 'data-path-selector');
    if (!((_list2 = list) !== null && _list2 !== void 0 && _list2.length)) return null;
    return h("div", {
      "class": "ucd-dataPathSelector-dsActions"
    }, [list.map(x => {
      if (x.vnode) return x.vnode;
      return h("div", {
        "on": {
          "click": x.execute
        },
        "class": "ucd-dataPathSelector-dsActionDefaultItem"
      }, [!!x.icon && h("i", {
        "class": x.icon
      }), x.title || x.key]);
    })]);
  }
  handleInputBoxMouseEnter(ev) {
    ev.target.select();
  }
  render() {
    const h = arguments[0];
    const hasError = !!this.hasError || !this.dataStub;
    return h("div", {
      "class": "ucd-dataPathSelector"
    }, [h("div", {
      "class": "ucd-dataPathSelector-row1"
    }, [h("div", {
      "ref": "placeProvider",
      "class": "ucd-dataPathSelector-placeProvider"
    }), h("input", {
      "domProps": {
        "value": this.value || ''
      },
      "class": mergeClassName('uc-inputbox', 'ucd-dataPathSelector-inputBox', hasError && 'hasError'),
      "attrs": {
        "readonly": true,
        "placeholder": this.placeholder
      },
      "on": {
        "mouseenter": this.handleInputBoxMouseEnter,
        "click": this.handleInputBoxClick
      }
    }), !!this.canCreateStateVariable && h("button", {
      "on": {
        "click": this.createStateVariable
      },
      "class": "uc-button isPrimary"
    }, ["\u65B0\u5EFA\u53D8\u91CF"]), !!this.canEditStateVariable && h("button", {
      "on": {
        "click": this.editStateVariable
      },
      "class": "uc-button"
    }, ["\u7F16\u8F91\u53D8\u91CF"]), this.$slots.actions]), this.dsActionsSlot]);
  }
};
DataPathSelector = __decorate([Component({
  name: 'DataPathSelector',
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  props: {
    value: {
      required: true
    },
    selectorOnly: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Function,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    exampleSchema: {
      default: null
    },
    exampleVariableName: {
      type: String,
      default: null
    },
    alwaysShowCreateButton: {
      type: Boolean,
      default: false
    } // 是否总是显示创建按钮
  },
  model: {
    prop: 'value',
    event: 'change'
  }
})], DataPathSelector);
export default DataPathSelector;
//# sourceMappingURL=index.js.map
